var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "invite-list" }, [
    _vm._m(0),
    _c(
      "tbody",
      _vm._l(_vm.channel.data, function (invite) {
        return _c("tr", { key: invite.hostmask }, [
          _c(
            "td",
            { staticClass: "hostmask" },
            [
              _c("ParsedMessage", {
                attrs: { network: _vm.network, text: invite.hostmask },
              }),
            ],
            1
          ),
          _c("td", { staticClass: "invitened_by" }, [
            _vm._v(_vm._s(invite.invited_by)),
          ]),
          _c("td", { staticClass: "invitened_at" }, [
            _vm._v(_vm._s(_vm.localetime(invite.invited_at))),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "hostmask" }, [_vm._v("Ftuar")]),
        _c("th", { staticClass: "invitened_by" }, [_vm._v("Ftuar nga")]),
        _c("th", { staticClass: "invitened_at" }, [_vm._v("Ftuar ne")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }